import { MedicalInsurance } from '../../models/Entities/MedicalInsurances/MedicalInsurance';
import { CommonState } from '../common/state/commonState';

export interface MedicalInsuranceState extends CommonState<MedicalInsurance> {}

export const MedicalInsuranceUnloadState: any = {
  // loading all
  isLoadingAll: false,
  isLoadingAllSuccess: undefined,
  FailGettingAll: false,

  // loading one
  isLoadingOne: false,
  isLoadingOneSuccess: undefined,
  FailGettingOne: false,

  // saving
  isSaving: false,
  isSavingSuccess: undefined,
  FailSaving: false,

  // adding
  isAdding: false,
  isAddingSuccess: undefined,
  FailAdding: false,

  // deleting
  isDeletingOne: false,
  isDeletingOneSuccess: undefined,
  FailDeletingOne: false,

  isFiltered: false,
  filterCriteria: undefined,

  list: [],
  Selected: undefined,
  Error: undefined
};
